import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const getStage = (application, location) => {
  if (location.pathname.indexOf('/status') !== -1) {
    return 'status';
  }

  if (location.pathname.indexOf('/director') !== -1) {
    return 'people-with-significant-control';
  }

  return application.stage;
}

const Layout = () => {
  const { application } = useSelector((state) => state);
  const location = useLocation();
  const stage = getStage(application, location);

  let stageNumber = 1;

  if (stage === 'bank') {
    stageNumber = 2;
  } else if (stage === 'people-with-significant-control') {
    stageNumber = 3;
  } else if (stage === 'status') {
    stageNumber = 4;
  } 

  const inactive = {
    li: `flex w-full relative text-gray-900  after:content-['']  after:w-full after:h-0.5  after:bg-gray-200 after:inline-block after:absolute lg:after:top-5  after:top-3 after:left-4`,
    li_end: `flex w-auto relative`,
    span: `w-6 h-6 bg-gray-50 border-2 border-gray-200 rounded-full flex justify-center items-center mx-auto mb-3 text-sm  lg:w-10 lg:h-10`
  };

  const active = {
    li: `flex w-full relative text-gray-900  after:content-['']  after:w-full after:h-0.5  after:bg-violet-300 after:inline-block after:absolute lg:after:top-5  after:top-3 after:left-4`,
    li_end: `flex w-auto relative`,
    span: `w-6 h-6 text-white bg-violet-800 border-2 border-gray-200 rounded-full flex justify-center items-center mx-auto mb-3 text-sm  lg:w-10 lg:h-10`
  }

  const inProgress = {
    li: `flex w-full relative text-gray-900  after:content-['']  after:w-full after:h-0.5  after:bg-gray-200 after:inline-block after:absolute lg:after:top-5  after:top-3 after:left-4 font-bold`,
    li_end: `flex w-auto relative`,
    span: `w-6 h-6 text-violet-800 bg-violet-100 border-2 border-violet-800 rounded-full flex justify-center items-center mx-auto mb-3 text-sm  lg:w-10 lg:h-10`
  }

  return (
    <div className="mt-8 mb-16 text-white">
      <ol className="flex items-center w-full text-xs text-gray-900 font-medium sm:text-base">
        <li className={ stageNumber === 1 ? inProgress.li : active.li }>
          <div className="block whitespace-nowrap z-10">
            <span className={ stageNumber === 1 ? inProgress.span : active.span }>
              1
            </span>{" "}
            Merchant
          </div>
        </li>
        <li className={ stageNumber < 2 ? inactive.li : stageNumber === 2 ? inProgress.li : active.li }>
          <div className="block whitespace-nowrap z-10">
            <span className={ stageNumber < 2 ? inactive.span : stageNumber === 2 ? inProgress.span : active.span }>
              2
            </span>{" "}
            Banking
          </div>
        </li>
        <li className={ stageNumber < 3 ? inactive.li : stageNumber === 3 ? inProgress.li : active.li }>
          <div className="block whitespace-nowrap z-10">
            <span className={ stageNumber < 3 ? inactive.span : stageNumber === 3 ? inProgress.span : active.span }>
              3
            </span>{" "}
            Directors
          </div>
        </li>
        <li className={ stageNumber < 4 ? inactive.li_end : stageNumber === 4 ? inProgress.li_end : active.li_end }>
          <div className="block whitespace-nowrap z-10">
            <span className={ stageNumber < 4 ? inactive.span : stageNumber === 4 ? inProgress.span : active.span }>
              4
            </span>{" "}
            Status
          </div>
        </li>
      </ol>
    </div>
  )
};

export default Layout;
